import React, { useEffect } from 'react'

import { useAppContext } from "AppContext"

import ImgDisplayer from 'ImgDisplayer';

const transformPercentage = (i) => Math.round(i)

const Thumbnail = (obj) =>  {
    const {setPopupOpen, setCurrentPic, threshold } = useAppContext()

    const getColor = (i) => i >= threshold ? 'bg-red-500' : 'bg-green-700'

    const onClick = () => {
        setCurrentPic(obj)
        setPopupOpen(true)
    }

    useEffect(() => console.log(obj), [])

    return (
        <div className="p-0 m-0">
            <div className="relative p-0 m-2 rounded-md">

                <div className={`absolute flex align-center items-center  right-0 z-10 float-right w-14 h-12 rounded-tr-md rounded-bl-lg bg-red-500 opacity-95 ${getColor(obj.scratch)}`}>
                    <p className="text-center flex-grow font-bold text-xl"> {`${transformPercentage(obj.scratch)}%`}</p>
                </div>
                <div className="w-64 rounded-md shadow-lg">
                <ImgDisplayer src={obj.thumbnailUrl} box={obj.scratch >= threshold && obj.box} />
                </div>
                <div className="absolute transition left-0 top-0 w-64 h-64 z-10 bg-black opacity-0 hover:opacity-80 rounded-md" onClick={onClick}></div>
            </div>
        </div>
    )
}

export default Thumbnail
